import api, { transformCursorResponse, transformRequest, transformResponse } from "services/api";
import { downloadFile } from "common/utils";

export const paymentsApi = api
  .enhanceEndpoints({
    addTagTypes: [
      "PaymentIntents",
      "PaymentTransactions",
      "DebtorAccounts",
      "PaymentMethods",
      "PaymentAllocations",
    ],
  })
  .injectEndpoints({
    endpoints: (build) => ({
      bulkCreatePaymentIntents: build.mutation({
        query: (payload) => ({
          url: `/api/v1/core/debtors/${payload.debtorId}/payment-intents/bulk-create/preview/`,
          method: "POST",
          body: transformRequest(payload),
        }),
        transformResponse: (response) => transformResponse(response),
        invalidatesTags: () => [
          { type: "PaymentIntents", id: "LIST" },
          { type: "DebtorAccounts", id: "LIST" },
          { type: "Lawsuits", id: "LIST" },
        ],
      }),
      createCardPaymentMethod: build.mutation({
        query: (payload) => ({
          url: `/api/v1/core/debtors/${payload.debtorId}/payment-methods/create-card-from-number/`,
          method: "POST",
          body: transformRequest(payload),
        }),
        transformResponse: (response) => transformResponse(response),
      }),
      createAchPaymentMethod: build.mutation({
        query: (payload) => ({
          url: `/api/v1/core/debtors/${payload.debtorId}/payment-methods/create-ach-from-number/`,
          method: "POST",
          body: transformRequest(payload),
        }),
        transformResponse: (response) => transformResponse(response),
      }),
      createLoggingPaymentMethod: build.mutation({
        query: (payload) => ({
          url: `/api/v1/core/debtors/${payload.debtorId}/payment-methods/create/`,
          method: "POST",
          body: transformRequest(payload),
        }),
        transformResponse: (response) => transformResponse(response),
      }),
      getAccountPaymentSettings: build.query({
        query: (payload) =>
          `/api/v1/core/accounts/payment-settings/?account_id=${payload.accountIds}`,
        transformResponse: (response) => transformResponse(response),
        // providesTags: (result) => [{ type: "Invoices", id: result.id }],
      }),
      getPaymentMethodOptions: build.query({
        query: (payload) => `/api/v1/core/debtors/${payload.debtorId}/payment-methods/`,
        transformResponse: (response) => transformResponse(response),
        // providesTags: (result) => [{ type: "Invoices", id: result.id }],
      }),
      getPaymentIntents: build.query({
        query: (payload) => ({
          url: `/api/v1/core/debtors/${payload.debtorId}/payment-intents/`,
          method: "POST",
          body: transformRequest(payload),
        }),
        transformResponse: (response) => transformResponse(response),
        providesTags: () => [{ type: "PaymentIntents", id: "LIST" }],
      }),
      getPaymentTransactions: build.query({
        query: (payload) =>
          `/api/v1/core/debtors/${payload.debtorId}/payment-transactions/?payment_intent_id=${payload.paymentIntentId}`,
        transformResponse: (response) => transformResponse(response),
        providesTags: () => [{ type: "PaymentTransactions", id: "LIST" }],
      }),
      createPaymentIntents: build.mutation({
        query: (payload) => ({
          url: `/api/v1/core/debtors/${payload.debtorId}/payment-intents/create/`,
          method: "POST",
          body: transformRequest(payload),
        }),
        transformResponse: (response) => transformResponse(response),
        invalidatesTags: () => [
          { type: "PaymentIntents", id: "LIST" },
          { type: "DebtorAccounts", id: "LIST" },
          { type: "Lawsuits", id: "LIST" },
        ],
      }),
      refundPaymentIntent: build.mutation({
        query: (payload) => ({
          url: `/api/v1/core/debtors/${payload.debtorId}/payment-intents/${payload.paymentIntentId}/refund/`,
          method: "POST",
          body: transformRequest(payload),
        }),
        transformResponse: (response) => transformResponse(response),
        invalidatesTags: () => [
          { type: "PaymentIntents", id: "LIST" },
          { type: "PaymentTransactions", id: "LIST" },
          { type: "DebtorAccounts", id: "LIST" },
        ],
      }),
      voidPaymentIntent: build.mutation({
        query: (payload) => ({
          url: `/api/v1/core/debtors/${payload.debtorId}/payment-intents/${payload.paymentIntentId}/void/`,
          method: "POST",
          body: transformRequest(payload),
        }),
        transformResponse: (response) => transformResponse(response),
        invalidatesTags: () => [
          { type: "PaymentIntents", id: "LIST" },
          { type: "PaymentTransactions", id: "LIST" },
          { type: "DebtorAccounts", id: "LIST" },
        ],
      }),
      clearOverpayments: build.mutation({
        query: (payload) => ({
          url: `/api/v1/core/debtors/${payload.debtorId}/payment-intents/${payload.paymentIntentId}/clear-overpayments/`,
          method: "POST",
          body: transformRequest(payload),
        }),
        transformResponse: (response) => transformResponse(response),
        invalidatesTags: () => [
          { type: "PaymentIntents", id: "LIST" },
          { type: "DebtorAccounts", id: "LIST" },
        ],
      }),
      bulkDebtorDeletePaymentIntents: build.mutation({
        query: (payload) => ({
          url: `/api/v1/core/debtors/${payload.debtorId}/payment-intents/bulk-delete/`,
          method: "POST",
          body: transformRequest(payload),
        }),
        invalidatesTags: () => [
          { type: "PaymentIntents", id: "LIST" },
          { type: "DebtorAccounts", id: "LIST" },
        ],
      }),
      bulkDeleteScheduledPaymentIntents: build.mutation({
        query: (payload) => ({
          url: `/api/v1/core/debtors/${payload.debtorId}/payment-intents/bulk-delete-scheduled-payments/`,
          method: "POST",
          body: transformRequest(payload),
        }),
        invalidatesTags: () => [
          { type: "PaymentIntents", id: "LIST" },
          { type: "DebtorAccounts", id: "LIST" },
        ],
      }),
      unsettlePaymentIntent: build.mutation({
        query: (payload) => ({
          url: `/api/v1/core/debtors/${payload.debtorId}/payment-intents/${payload.paymentIntentId}/undo-settlement/`,
          method: "POST",
          body: transformRequest(payload),
        }),
        invalidatesTags: () => [
          { type: "PaymentIntents", id: "LIST" },
          { type: "DebtorAccounts", id: "LIST" },
        ],
      }),
      executePaymentIntent: build.mutation({
        query: (payload) => ({
          url: `/api/v1/core/debtors/${payload.debtorId}/payment-intents/${payload.paymentIntentId}/execute/`,
          method: "POST",
          body: transformRequest(payload),
        }),
        transformResponse: (response) => transformResponse(response),
        invalidatesTags: () => [
          { type: "PaymentIntents", id: "LIST" },
          { type: "DebtorAccounts", id: "LIST" },
        ],
      }),
      calculateBalanceFromSchedule: build.query({
        query: (payload) => ({
          url: `/api/v1/core/debtors/${payload.debtorId}/payment-intents/calculate-balance-from-schedule/`,
          method: "POST",
          body: transformRequest(payload),
        }),
        transformResponse: (response) => transformResponse(response),
      }),
      getPaymentIntentsList: build.query({
        query: (payload) => ({
          url: `/api/v1/core/payment-intents/`,
          method: "POST",
          body: transformRequest(payload),
        }),
        transformResponse: (response) => transformCursorResponse(response),
        providesTags: () => [{ type: "PaymentIntents", id: "LIST" }],
      }),
      bulkDeletePaymentIntents: build.mutation({
        query: (payload) => ({
          url: `/api/v1/core/payment-intents/bulk-delete/`,
          method: "POST",
          body: transformRequest(payload),
        }),
        invalidatesTags: () => [{ type: "PaymentIntents", id: "LIST" }],
      }),
      bulkVoidPaymentIntents: build.mutation({
        query: (payload) => ({
          url: `/api/v1/core/payment-intents/bulk-void/`,
          method: "POST",
          body: transformRequest(payload),
        }),
        invalidatesTags: () => [{ type: "PaymentIntents", id: "LIST" }],
      }),
      bulkExecutePaymentIntents: build.mutation({
        query: (payload) => ({
          url: `/api/v1/core/payment-intents/bulk-execute/`,
          method: "POST",
          body: transformRequest(payload),
        }),
        invalidatesTags: () => [{ type: "PaymentIntents", id: "LIST" }],
      }),
      bulkRefundPaymentIntents: build.mutation({
        query: (payload) => ({
          url: `/api/v1/core/payment-intents/bulk-refund/`,
          method: "POST",
          body: transformRequest(payload),
        }),
        invalidatesTags: () => [{ type: "PaymentIntents", id: "LIST" }],
      }),
      calculateConvenienceFees: build.mutation({
        query: (payload) => ({
          url: `/api/v1/core/payment-intents/convenience-fees/`,
          method: "POST",
          body: transformRequest(payload),
        }),
        transformResponse: (response) => transformResponse(response),
        invalidatesTags: () => [{ type: "PaymentIntents", id: "LIST" }],
      }),
      archivePaymentMethod: build.mutation({
        query: (payload) => ({
          url: `/api/v1/core/debtors/${payload.debtorId}/payment-methods/${payload.paymentMethodId}/archive/`,
          method: "POST",
          body: transformRequest({
            delete_scheduled_payment_intents: payload.deleteScheduledPaymentIntents,
          }),
        }),
        invalidatesTags: () => [{ type: "PaymentMethods", id: "LIST" }],
      }),
      reallocatePaymentIntents: build.mutation({
        query: (payload) => ({
          url: `/api/v1/core/payment-intents/${payload.paymentIntentId}/reallocate/`,
          method: "POST",
          body: transformRequest(payload),
        }),
        invalidatesTags: () => [
          { type: "PaymentIntents", id: "LIST" },
          { type: "PaymentAllocations", id: "LIST" },
        ],
      }),
      generatePaymentReceipt: build.mutation({
        query: (payload) => ({
          url: `/api/v1/core/payment-intents/${payload.paymentIntentId}/generate-receipt/`,
          method: "POST",
          body: transformRequest({ letterTemplateId: payload.letterTemplateId }),
          responseHandler: (response) => response.blob(),
        }),
        transformResponse: downloadFile,
      }),
    }),
    overrideExisting: false,
  });

export const {
  useReallocatePaymentIntentsMutation,
  useCreateAchPaymentMethodMutation,
  useCreateCardPaymentMethodMutation,
  useCreateLoggingPaymentMethodMutation,
  useCreatePaymentIntentsMutation,
  useBulkDebtorDeletePaymentIntentsMutation,
  useBulkDeleteScheduledPaymentIntentsMutation,
  useExecutePaymentIntentMutation,
  useGetAccountPaymentSettingsQuery,
  useGetPaymentIntentsQuery,
  useLazyGetPaymentIntentsQuery,
  useGetPaymentMethodOptionsQuery,
  useGetPaymentTransactionsQuery,
  useRefundPaymentIntentMutation,
  useUnsettlePaymentIntentMutation,
  useVoidPaymentIntentMutation,
  useLazyCalculateBalanceFromScheduleQuery,
  useGetPaymentIntentsListQuery,
  useBulkDeletePaymentIntentsMutation,
  useBulkVoidPaymentIntentsMutation,
  useClearOverpaymentsMutation,
  useBulkExecutePaymentIntentsMutation,
  useBulkRefundPaymentIntentsMutation,
  useCalculateConvenienceFeesMutation,
  useArchivePaymentMethodMutation,
  useBulkCreatePaymentIntentsMutation,
  useGeneratePaymentReceiptMutation,
} = paymentsApi;
